import Axios from 'axios';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import Visibility from 'react-visibility-sensor';

export default class VisibilityPixel extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            hasFired: false,
        };
    }

    static propTypes = {
        metrics: PropTypes.object,
    };

    static defaultProps = {
        visibilityCallback: null,
        metrics: null,
    };

    onVisChange(isVis) {
        if (isVis && !this.state.hasFired) {
            this.setState({ hasFired: true });

            this.props.visibilityCallback && this.props.visibilityCallback();

            if (!this.props.metrics) {
                return;
            }

            const { metrics } = this.props;

            metrics.type = 'pixel';

            EmitMetric(metrics, 'pixel');
        }
    }

    static setLastActionParams = (lac, lat) => {
        let trackingPropsHsh = getTrackingPropsCookie() || {};

        trackingPropsHsh.last_action_category = lac;
        trackingPropsHsh.last_action_type = lat;

        Cookies.set('TRACKING_PROPS', `j:${JSON.stringify(trackingPropsHsh)}`, {
            expires: 1 / 12,
        }); //2hours
    };

    render() {
        return (
            <div style={{ width: '1px', height: '1px' }}>
                <NoSSR>
                    <Visibility onChange={(isVis) => this.onVisChange(isVis)}>
                        <div style={{ width: '1px', height: '1px' }} />
                    </Visibility>
                </NoSSR>
            </div>
        );
    }
}

const buildMetrics = (metrics, type) => {
    metrics.url = window.location.pathname;
    let url = new URL(window.location);

    if (url.searchParams.get('utm_source')) {
        metrics.utmSource = url.searchParams.get('utm_source');
    }

    if (url.searchParams.get('utm_campaign')) {
        metrics.utmCampaign = url.searchParams.get('utm_campaign');
    }

    if (url.searchParams.get('utm_medium')) {
        metrics.utmMedium = url.searchParams.get('utm_medium');
    }

    if (url.searchParams.get('LAT')) {
        metrics.last_action_type = url.searchParams.get('LAT');
    }

    if (url.searchParams.get('LAC')) {
        metrics.last_action_category = url.searchParams.get('LAC');
    }

    if (isDebug()) {
        console.log(`Debug ${type} metrics:`, metrics);
    }

    let metricsString = JSON.stringify(metrics);
    return encodeURIComponent(metricsString);
};

const getPageMetrics = () => {
    let metricsData = { source: 'frontend' };
    if (
        window &&
        window.globalPageData &&
        window.globalPageData.analytics &&
        window.globalPageData.analytics.metrics
    ) {
        metricsData = window.globalPageData.analytics.metrics;
    }
    return metricsData;
};

const isDebug = () => {
    if (window && window.globalPageData && window.globalPageData.analytics) {
        return window.globalPageData.analytics.debug === true;
    }
    return false;
};

const getMetricData = (metrics) => {
    const fullMetrics = Object.assign({}, getPageMetrics(), metrics);
    return fullMetrics;
};
export const EmitPage = (metrics = {}, frontendRoutingEnabled) => {
    if (
        !window ||
        (window.__pageMetricsFired === 1 && !frontendRoutingEnabled)
    ) {
        return;
    }

    if (window) {
        window.__pageMetricsFired = 1;
    }

    Axios.get(
        '/_metrics/page?metrics=' + buildMetrics(getMetricData(metrics), 'page')
    );
};

export const EmitMetric = (metrics = {}, type = 'manual') => {
    Axios.get(
        '/_metrics/emit?metrics=' + buildMetrics(getMetricData(metrics), 'emit')
    );
};

export const getTrackingPropsCookie = () => {
    const trackingProps = Cookies.get('TRACKING_PROPS');

    return trackingProps ? JSON.parse(trackingProps.split('j:')[1]) : null;
};

export const getValueFromTrackingProps = (key) => {
    let trackingPropsHsh = getTrackingPropsCookie();

    return trackingPropsHsh ? trackingPropsHsh[key] : null;
};
